export default __webpack_public_path__ + "static/Vive_el_cole_Nol-e260db4392d17253d050d546d9ceabab.png";